export default __webpack_public_path__ + "static/media/two.f7293f68.svg";